<template>
    <nav class="sidebar-left" :class="[ sidebarStatus? 'open':'close' ]">
        <div class="header">
            <div class="logo-details">
                <div class="logo user-select-none">
                    <a href="javascript:void(0);">
                        <figure>
                            <img src="/assets/img/logo/logo.svg" alt="Rehberim Sensin" draggable="false">
                        </figure>
                    </a>
                </div>
                <a class="btn-sidebar-state" @click="changeSideBar">
                    <i class="icon" :class="[ sidebarStatus ? 'icon icon-bars' : 'icon-bars']"></i>
                </a>
            </div>
        </div>
        <div class="menu">
            <ul class="menu-link">
                <slot></slot>
            </ul>
        </div>
    </nav>
</template>
<script>
    import { reactive, toRefs, onMounted, onBeforeUnmount } from "vue";
    import { useStore } from "vuex";

    import { Constants } from "@/helpers/constants";
    import { Links } from "@/helpers/links";
    import { appData, C } from "@/helpers/global";
    import { Web } from "@/helpers/web";

    import { StoreUser } from "@/store/constants";
    
    export default {
        unmounted() { this.bus.leave(); },
        setup() {
            const store = useStore();

            const e = reactive({
                bus: appData.eventBus(Constants.Key.LeftSidebarStatus),
                leftSidebarStatus: {
                    set(val) { e.bus.set(Constants.Key.LeftSidebarStatus, val); }
                },
                sidebarStatus: (() => {
                    const tabletLandscape = typeof window !== 'undefined' && window.innerWidth >= 768 && window.innerWidth <= 1180 && window.innerWidth > window.innerHeight;
                    return tabletLandscape ? false : C.Bool(localStorage.getItem('left-sidebar') ?? true);
                })(),
                tabletLandscape: typeof window !== 'undefined' && window.innerWidth >= 768 && window.innerWidth <= 1180 && window.innerWidth > window.innerHeight,
                changeSideBar() {
                    e.sidebarStatus = !e.sidebarStatus;
                    e.leftSidebarStatus.set(e.sidebarStatus);
                    localStorage.setItem('left-sidebar', e.sidebarStatus ? '1': '0');
                },
            });
            const syncTabletState = () => {
                const tabletLandscape = window.innerWidth >= 768 && window.innerWidth <= 1180 && window.innerWidth > window.innerHeight;
                if (tabletLandscape && !e.tabletLandscape) {
                    e.sidebarStatus = false;
                    e.leftSidebarStatus.set(false);
                }
                e.tabletLandscape = tabletLandscape;
            };
            e.leftSidebarStatus.set(e.sidebarStatus);
            onMounted(() => window.addEventListener('resize', syncTabletState));
            onBeforeUnmount(() => window.removeEventListener('resize', syncTabletState));
            return { ...toRefs(e) };
        },
    };
</script>